function init() {
  if (document.querySelector('.reason-accordion')) {
    $('.reason-accordion .anchors a').first().addClass('active');
    $('.reason-accordion .info').first().addClass('active');

    // Show Info On Click
    $('.reason-accordion .anchors a').on('click', function (e) {
      e.preventDefault();
      $('.reason-accordion .anchors a, .reason-accordion .info').removeClass('active');
      $(this).addClass('active');
      $('.reason-accordion .info:nth-child(' + ($(this).index() + 1) + ')').addClass('active');
    });

    // Show info on hover
    $('.reason-accordion .anchors a').on('mouseenter', function () {
      $(this).trigger('click');
    });
  }
}

export { init }
